import React, { useEffect, useState, useRef } from "react";
import ascendCargoLogo from "../../../assets/ACS-Images/Ascend_cargo_systems.png";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import UserProfileDropdown from "../ACS-Header-Action/ProfileDropdown/UserProfileDropdown";
import Cookies from "js-cookie";
import {
  Bell,
  HelpCircle,
  MessageSquareText,
  UserCircle2,
  Moon,
  Sun,
} from "lucide-react";
import { useTheme } from "../../../context/ThemeContext";
import NotificationDropdown from "../ACS-Header-Action/NotificationDropdown/NotificationDropdown";
import HelpDropdown from "../ACS-Header-Action/HelpDropdown/HelpDropdown";

const Header = ({ isCollapsed }) => {
  const { width } = useWindowDimensions();
  const [userName, setUserName] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const { theme, toggleTheme } = useTheme();
  const bellRef = useRef(null);
  const [showHelp, setShowHelp] = useState(false);
  const helpRef = useRef(null);
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);


  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) return "Morning";
    if (hour >= 12 && hour < 17) return "Afternoon";
    if (hour >= 17 && hour < 21) return "Evening";
    return "Evening";
  };

  useEffect(() => {
    const storedData = Cookies.get("userData");
    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);
        setUserName(parsed.name?.split(" ")[0] || "User");
      } catch {
        setUserName("User");
      }
    }
  }, []);

  // 🔹 Close dropdown when clicked outside
  useEffect(() => {
  const handleClickOutside = (e) => {
    if (bellRef.current && !bellRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
    if (helpRef.current && !helpRef.current.contains(e.target)) {
      setShowHelp(false);
    }
    if (profileRef.current && !profileRef.current.contains(e.target)) {
      setShowProfile(false);
    }
  };

  document.addEventListener("mouseup", handleClickOutside);   // 🔥 FIXED
  return () => document.removeEventListener("mouseup", handleClickOutside);
}, []);



  return (
    <header className="w-full bg-white dark:bg-acs-dark-surface shadow-md flex flex-col h-auto transition-none">
      {/* 🔹 Top Section */}
      <div className="flex items-center justify-between px-fluid-2 md:px-fluid-1 py-fluid-0.5 flex-wrap md:flex-nowrap">
        {/* Logo */}
        <div className="flex items-center gap-fluid-1">
          <div
            className={`transition-none ${
              isCollapsed ? "ml-0" : "ml-fluid-1"
            }`}
          >
            <img
              src={ascendCargoLogo}
              alt="Ascend Cargo Systems"
              className="w-[clamp(2.5rem,5vw,3.5rem)] h-auto dark:brightness-200 transition-none"
            />
          </div>
        </div>

        {/* 🔹 Icons */}
        <div className="flex items-center w-full md:w-auto px-fluid-1 py-fluid-1 gap-fluid-2.5">
          <div className="flex-fluid-1" />

          {/* Theme toggle */}
          <button
            onClick={toggleTheme}
            className="p-1.5 rounded-md hover:bg-gray-200 dark:hover:bg-acs-dark-hover transition"
            aria-label="Toggle dark mode"
          >
            {theme === "dark" ? (
              <Sun className="w-fluid-icon-md h-fluid-icon-md text-yellow-400" />
            ) : (
              <Moon className="w-fluid-icon-md h-fluid-icon-md text-gray-700 hover:text-acs-accent" />
            )}
          </button>

          {/* Message */}
          <MessageSquareText
            className="w-fluid-icon-xl h-fluid-icon-md text-gray-700 dark:text-acs-dark-text hover:text-acs-accent dark:hover:text-yellow-400 transition-none cursor-pointer"
          />

          {/* Bell */}
          <div ref={bellRef} className="relative">
            <Bell
              // onClick={() => setIsDropdownOpen((prev) => !prev)}
              className="w-fluid-icon-xl h-fluid-icon-md text-gray-700 dark:text-acs-dark-text hover:text-acs-accent dark:hover:text-yellow-400 transition-none cursor-pointer"
            />
            {isDropdownOpen && (
              <div className="absolute right-0 top-[calc(100%+0.5rem)] z-[200]">
                <NotificationDropdown setUnreadCount={setUnreadCount} />
              </div>
            )}
          </div>

          {/* Help */}
          <div ref={helpRef} className="relative">
            <HelpCircle
              onClick={() => setShowHelp((prev) => !prev)}
              className="w-fluid-icon-xl h-fluid-icon-md text-gray-700 dark:text-acs-dark-text hover:text-acs-accent dark:hover:text-yellow-400 transition-none cursor-pointer"
            />
            {showHelp && (
              <div className="absolute right-0 top-[calc(100%+0.5rem)] z-[200]">
                <HelpDropdown onClose={() => setShowHelp(false)} />
              </div>
            )}
          </div>

          {/* User */}
          <div ref={profileRef} className="relative">
            <UserCircle2
              onClick={() => setShowProfile(prev => !prev)}
              className="w-fluid-icon-xl h-fluid-icon-md 
                        text-gray-700 dark:text-acs-dark-text 
                        hover:text-acs-accent dark:hover:text-yellow-400
                        transition-none cursor-pointer"
            />

            {showProfile && (
              <div className="absolute right-0 top-[calc(100%+0.5rem)] z-[210]">
                <UserProfileDropdown
                    ref={profileRef}      // <-- IMPORTANT
                    open={showProfile}
                    onClose={() => setShowProfile(false)}
                />

              </div>
            )}
          </div>


        </div>
      </div>

      {/* Divider */}
      <div className="border-b border-gray-300 dark:border-acs-dark-border w-full"></div>

      {/* Greeting */}
      <div className="flex items-center justify-between px-fluid-1.5 md:px-fluid-1 py-fluid-0.5 flex-wrap md:flex-nowrap gap-fluid-0.5">
        <h4 className="text-black dark:text-acs-dark-text font-bold text-fluid-xl ml-2 font-roboto transition-none">
          Good {getGreeting()}, {userName}!
        </h4>
      </div>
    </header>
  );
};

export default Header;
